import { BnAction } from '../../common/bn-action';

class CreateImportAction extends BnAction {
  static get properties() {
    return {
      filename: { type: String },
    };
  }

  constructor() {
    super();
    this.actionname = 'create-import';
    this.submittext = 'Create';
  }

  preRender(action) {
    const field = action.getField('name');
    field.value = this.filename;
    field.type = 'hidden';
  }
}

window.customElements.define('create-import-action', CreateImportAction);
